function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 22,
  width: 150,
  height: 109
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2072 22.1592L149.506 52.1857L131.592 130.518L0.293446 100.492L18.2072 22.1592Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.805 102.01L110.815 102.008L110.874 101.991C111.445 101.838 111.951 101.506 112.319 101.043L148.029 57.2039C148.871 56.1699 148.96 54.7126 148.248 53.5839L147.005 51.6136L109.542 99.1872L54.6528 58.6478L7.75973 71.0556C7.21671 71.1998 6.8775 71.6262 6.787 72.1009C6.78587 72.1059 6.78375 72.1114 6.78345 72.1165C6.78214 72.1222 6.78001 72.1277 6.77971 72.1328C6.7784 72.1385 6.77627 72.1441 6.77597 72.1492C6.77466 72.1549 6.77272 72.1596 6.77223 72.1655C6.77111 72.1704 6.76898 72.176 6.76868 72.181C6.76737 72.1868 6.76524 72.1923 6.76494 72.1974C6.76363 72.2031 6.76151 72.2087 6.7612 72.2137C6.75989 72.2195 6.75796 72.2242 6.75746 72.2301C6.75634 72.235 6.75422 72.2405 6.75373 72.2464C6.7526 72.2513 6.75048 72.2569 6.74999 72.2628C6.74887 72.2677 6.74674 72.2732 6.74644 72.2783C6.74513 72.284 6.74319 72.2888 6.7427 72.2947C6.74158 72.2996 6.73945 72.3051 6.73896 72.311C6.73784 72.3159 6.73571 72.3214 6.73522 72.3274C6.7341 72.3323 6.73197 72.3378 6.73167 72.3429C6.73036 72.3486 6.72842 72.3533 6.72793 72.3592C6.72662 72.365 6.72468 72.3697 6.72419 72.3756C6.72288 72.3813 6.72094 72.386 6.72045 72.3919C6.71933 72.3968 6.71721 72.4024 6.7169 72.4075C6.71559 72.4132 6.71365 72.4179 6.71316 72.4238C6.71186 72.4295 6.70973 72.4351 6.70943 72.4401C6.70812 72.4459 6.70618 72.4506 6.70569 72.4565C6.70457 72.4614 6.70244 72.4669 6.70213 72.472C6.70083 72.4778 6.6987 72.4833 6.6984 72.4884C6.69709 72.4941 6.69496 72.4996 6.69466 72.5047C6.69335 72.5104 6.69141 72.5152 6.69092 72.5211C6.6898 72.526 6.68767 72.5315 6.68718 72.5374C6.68606 72.5423 6.68393 72.5479 6.68344 72.5538C6.68232 72.5587 6.6802 72.5642 6.67989 72.5693C6.67858 72.575 6.67664 72.5797 6.67615 72.5856C6.67503 72.5905 6.67291 72.5961 6.67241 72.602C6.67129 72.6069 6.66917 72.6124 6.66868 72.6183C6.66755 72.6232 6.66543 72.6288 6.66512 72.6339C6.66382 72.6396 6.66188 72.6443 6.66139 72.6502C6.66008 72.6559 6.65814 72.6607 6.65765 72.6666C6.65634 72.6723 6.6544 72.677 6.65391 72.6829C6.65279 72.6878 6.65066 72.6933 6.65036 72.6984C6.64905 72.7042 6.64711 72.7089 6.64662 72.7148C6.64531 72.7205 6.64337 72.7252 6.64288 72.7311C6.64157 72.7369 6.63963 72.7416 6.63914 72.7475C6.63802 72.7524 6.6359 72.7579 6.63559 72.763C6.63428 72.7687 6.63216 72.7743 6.63185 72.7794C6.63054 72.7851 6.62842 72.7906 6.62811 72.7957C6.62681 72.8014 6.62487 72.8061 6.62438 72.8121C6.62325 72.817 6.62113 72.8225 6.62082 72.8276C6.61952 72.8333 6.61739 72.8388 6.61709 72.8439C6.61578 72.8496 6.61365 72.8552 6.61335 72.8603C6.61204 72.866 6.6101 72.8707 6.60961 72.8766C6.60849 72.8815 6.60636 72.8871 6.60587 72.893C6.60475 72.8979 6.60262 72.9034 6.60213 72.9093C6.60101 72.9142 6.59888 72.9198 6.59858 72.9248C6.59727 72.9306 6.59533 72.9353 6.59484 72.9412C6.59372 72.9461 6.5916 72.9516 6.5911 72.9575C6.5898 72.9633 6.58786 72.968 6.58737 72.9739C6.58624 72.9788 6.58412 72.9843 6.58381 72.9894C6.58251 72.9951 6.58057 72.9999 6.58008 73.0058C6.57877 73.0115 6.57683 73.0162 6.57634 73.0221C6.57503 73.0278 6.57309 73.0325 6.5726 73.0385C6.57148 73.0434 6.56935 73.0489 6.56905 73.054C6.56774 73.0597 6.56561 73.0652 6.56531 73.0703C6.564 73.0761 6.56187 73.0816 6.56157 73.0867C6.56026 73.0924 6.55832 73.0971 6.55783 73.103C6.55671 73.1079 6.55458 73.1135 6.55428 73.1186C6.55297 73.1243 6.55085 73.1298 6.55054 73.1349C6.54923 73.1406 6.54711 73.1462 6.5468 73.1513C6.5455 73.157 6.54356 73.1617 6.54307 73.1676C6.54194 73.1725 6.53982 73.178 6.53933 73.1839C6.53821 73.1889 6.53608 73.1944 6.53559 73.2003C6.53447 73.2052 6.53234 73.2107 6.53204 73.2158C6.53073 73.2215 6.52879 73.2263 6.5283 73.2322C6.52718 73.2371 6.52505 73.2426 6.52456 73.2485C6.52344 73.2534 6.52131 73.259 6.52082 73.2649C6.5197 73.2698 6.51757 73.2753 6.51727 73.2804C6.51596 73.2861 6.51402 73.2908 6.51353 73.2967C6.51222 73.3025 6.51028 73.3072 6.50979 73.3131C6.50849 73.3188 6.50655 73.3235 6.50605 73.3294C6.50493 73.3343 6.50281 73.3399 6.5025 73.345C6.5012 73.3507 6.49926 73.3554 6.49876 73.3613C6.49746 73.367 6.49552 73.3718 6.49503 73.3777C6.49372 73.3834 6.49178 73.3881 6.49129 73.394C6.49017 73.3989 6.48804 73.4044 6.48774 73.4095C6.48643 73.4153 6.4843 73.4208 6.484 73.4259C6.48269 73.4316 6.48056 73.4371 6.48026 73.4422C6.47895 73.448 6.47701 73.4527 6.47652 73.4586C6.4754 73.4635 6.47327 73.469 6.47297 73.4741C6.47166 73.4798 6.46954 73.4854 6.46923 73.4905C6.46792 73.4962 6.4658 73.5017 6.46549 73.5068C6.46418 73.5125 6.46225 73.5172 6.46175 73.5232C6.46063 73.5281 6.45851 73.5336 6.45802 73.5395C6.45689 73.5444 6.45477 73.5499 6.45428 73.5558C6.45316 73.5608 6.45103 73.5663 6.45073 73.5714C6.44942 73.5771 6.44748 73.5818 6.44699 73.5877C6.44587 73.5926 6.44374 73.5982 6.44325 73.6041C6.44194 73.6098 6.44 73.6145 6.43951 73.6204C6.43839 73.6253 6.43626 73.6309 6.43596 73.6359C6.43465 73.6417 6.43271 73.6464 6.43222 73.6523C6.43091 73.658 6.42897 73.6627 6.42848 73.6686C6.42717 73.6744 6.42524 73.6791 6.42474 73.685C6.42362 73.6899 6.4215 73.6954 6.42119 73.7005C6.41988 73.7062 6.41776 73.7118 6.41746 73.7169C6.32086 74.1919 6.4726 74.7169 6.92224 75.0562L56.6775 112.559C58.9312 114.258 61.8394 114.832 64.5709 114.119L109.398 102.408L110.269 102.181L110.821 102.021L110.805 102.01Z",
  fill: "#0B0B0C"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 48,
  width: 118,
  height: 75
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0875 48.9133L117.455 73.0097L106.033 122.955L0.665566 98.8589L12.0875 48.9133Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask1)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.6532 58.6476L7.75991 71.0563C6.6779 71.3421 6.40158 72.7497 7.29589 73.4238L57.0503 110.926C59.3049 112.625 62.2122 113.2 64.9437 112.486L111.19 100.405L54.6532 58.6476Z",
  fill: "#BABFC6"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.2241 104.626L87.4875 101.684L40.8281 67.2225L29.6031 70.1928L76.2241 104.626Z",
  fill: "#959CA3"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.572 101.139L100.366 98.3198L53.6641 63.8266L42.9062 66.6724L89.572 101.139Z",
  fill: "#959CA3"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.5249 70.7428L15.7652 73.8549L59.9125 107.13C60.4194 107.512 60.9908 107.778 61.6103 107.92C62.31 108.08 63.0471 108.069 63.7423 107.887L74.1394 105.171L27.5249 70.7428Z",
  fill: "#959CA3"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.6528 58.6474L86.3452 16.6479C87.3736 15.1259 89.4262 14.6991 90.9751 15.6855L146.184 50.8795C147.89 51.9654 148.272 54.2942 147.002 55.8676L111.19 100.405L54.6528 58.6474Z",
  fill: "#BABFC6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.9964 58.1621L88.2804 18.0295L88.3146 17.978C88.5838 17.5794 89.0445 17.4792 89.3812 17.5562C89.4924 17.5816 89.5991 17.6267 89.699 17.69L144.906 52.8836C145.24 53.0967 145.336 53.4084 145.363 53.5755C145.391 53.7427 145.4 54.0682 145.153 54.3754L110.767 97.1378L57.9964 58.1621Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.32194,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.0291 60.4021L107.81 29.2355L113.662 32.9657L65.2564 63.5243L61.0291 60.4021Z",
  fill: "#959CA3"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.32194,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.2822 74.6224L128.158 42.0917L132.202 44.8099L83.4653 76.9733L80.2822 74.6224Z",
  fill: "#959CA3"
});

var SvgLaptop = function SvgLaptop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 155,
    height: 132,
    viewBox: "0 0 155 132",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLaptop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Laptop.9c4edfab.svg";
export { ForwardRef as ReactComponent };